<div class="bubble-bar-container">
  <div
    class="bubble-bar"
    #bubbleContainer
  >
    <!-- Sliding selector (behind icons) -->
    <div
      class="bubble-selector"
      [class.dragging]="isDragging"
      [style.transform]="getSelectorTransform()"
    ></div>

    <!-- Fixed icons (above selector) -->
    @for (item of sortedItems; track item.id) {
      <div
        class="bubble-item"
        [class.under-selector]="isUnderSelector(item.id)"
        [attr.data-item-id]="item.id"
        [attr.aria-label]="item.label"
        [attr.aria-pressed]="isItemActive(item.id)"
        [attr.aria-disabled]="item.disabled"
        [attr.tabindex]="item.disabled ? -1 : 0"
        role="button"
        (click)="onItemClick(item.id)"
      >
        <ion-icon [name]="item.icon" class="bubble-icon"></ion-icon>
      </div>
    }

    <!-- Transparent overlay for dragging -->
    <div
      class="drag-overlay"
      [class.dragging]="isDragging"
      (mousedown)="onSelectorMouseDown($event)"
      (touchstart)="onSelectorTouchStart($event)"
      (mousemove)="onMouseMove($event)"
      (mouseup)="onMouseUp($event)"
      (mouseleave)="onMouseUp($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd($event)"
    ></div>
  </div>
</div>
